import { useContext, useEffect, useRef, useState } from "react";
import { ConfigContext } from "../Context/ConfigContext";

const Tabs = ({ p_subs, p_title, p_STR_ID, p_index, from }) => {

    var fromi = 0;
    var itemIndex = 0;

    const { treeCategories, gdcURL } = useContext(ConfigContext);
    const divRef = useRef(null);
    const [limit] = useState(from ? true : false);

    useEffect(() => {
        if (p_subs !== null && p_title !== null && p_STR_ID) {
            const section = document.getElementById('sec-' + p_STR_ID);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [p_STR_ID])

    const dir = localStorage.getItem('dir');


    return (
        <div ref={divRef} >
            {
                treeCategories &&
                treeCategories.length > 0
                &&
                Array.from({ length: limit ? 2 : Math.ceil(treeCategories.length / 6) }).map((_, index) => {
                    fromi = fromi + 6;

                    return (
                        <div
                            className="
    row
    row-cols-1
    row-cols-sm-2
    row-cols-md-3
    row-cols-lg-5
    g-4
    border-bottom
    justify-content-center
  "
                            dir={dir}
                            key={`pp-${index}`}>

                            {treeCategories && Array.from({ length: 5 }).map((_, ii) => {

                                if (!treeCategories[itemIndex]) {
                                    itemIndex++;
                                    return null;
                                }

                                const item = treeCategories[itemIndex];
                                itemIndex++;

                                return (
                                    <div
                                        className="col text-center"
                                        key={`section-tabs-${item.STR_ID}`}
                                        id={`sec-${item.STR_ID}`}
                                    >
                                        <div
                                            className={`card  py-3 card-effect shadow-none h-100 border-0  `}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {/* IMAGE */}
                                            <div className="d-flex align-items-center justify-content-center p-3">
                                                <img
                                                    alt={item.STR_NODE_NAME}
                                                    onError={({ currentTarget }) => {
                                                        currentTarget.onerror = null;
                                                        currentTarget.src = "https://placehold.co/100x100/FFFFFF/FFFFFF/png";
                                                    }}
                                                    src={`${gdcURL}/category-images/600x600/${item.STR_ID}`}
                                                    className="img-fluid"
                                                    style={{ maxHeight: "200px", maxWidth: "200px", background: '' }}
                                                />
                                            </div>

                                            {/* TITLE */}
                                            <div className="card-body p-2">
                                                <span
                                                    style={{
                                                        fontFamily: "Montserrat, Arial, sans-serif",
                                                        fontSize: "16px",
                                                        fontWeight: 500,
                                                        color: "#032f4a"
                                                    }}
                                                >
                                                    {item.STR_NODE_NAME}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    );

                })
            }
        </div>
    )
}

export default Tabs